//This is used to wrap functions that are called
//by React Query

export default function queryWrap(fn) {
  return async arrayKeys => {
    const [, ...args] = arrayKeys.queryKey;
    return await fn(...args);
  };
}
